import React from "react";

export const cardStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  borderRadius: 12,
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  padding: 24,
};

export const sectionTitleStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  paddingBottom: 16,
  borderBottom: "1px solid #f3f4f6",
  marginBottom: 16,
};

export const sectionTitleText: React.CSSProperties = {
  fontSize: 18,
  fontWeight: 700,
  color: "#111827",
  margin: 0,
  flex: 1,
};
